export function nonApiUrlPattern(backendApiUrl: string): RegExp {
	const allowedHosts = [new URL(backendApiUrl).hostname, 'firebaseio.com', 'googleapis.com'].map(host =>
		host.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
	);
	return new RegExp(`^(?!.*(${allowedHosts.join('|')})).*$`, 'i');
}
